
import { setDoc, doc, collection, query, where, onSnapshot,getDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useState, useEffect } from "react";
import { auth } from "../../utils/fipresConfig"; // Corrected path
import { database } from "../../utils/fipresConfig"; // Corrected path
import { BsSendPlusFill } from "react-icons/bs";
export default function NoteForm() {
  const [user, loading] = useAuthState(auth);
  const [note, setNote] = useState("");
  const [noteCount, setNoteCount] = useState(0);
  const [message, setMessage] = useState("");
 const [name,setName]=useState("")
 useEffect(() => {
  if (user) {
    const fetchUserName = async () => {
      const userDoc = await getDoc(doc(database, "users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        setName(userData.name); // Set the name from the users collection
      }
    };

    fetchUserName();

    const q = query(collection(database, "notes"), where("userId", "==", user.uid));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNoteCount(snapshot.size);
    });

    return () => unsubscribe();
  }
}, 
[user,database]);

        
    

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setMessage("User is not authenticated");
      return;
    }
    if (noteCount >= 3) {
      setMessage("You can only add up to 3 notes.");
      return;
    }
    try {
      const collectionRef = collection(database, "notes");
      const docRef = doc(collectionRef);
      await setDoc(docRef, {
        text: note,
        name:name ,
        userId: user.uid // Add userId field
      });
      setNote(""); // Clear the textarea after submission
      setMessage("");
    } catch (error) {
      setMessage(error.message);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Please log in to add notes.</div>;
  }

  return (
    <div className="noteform">
      
      <form onSubmit={handleSubmit} id="form">
        <div className="card_note">
          <label className="card_note_title" htmlFor="note-text">Note Text:</label>
          <textarea
            id="note-text"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="card_note_textarea"
            placeholder="Your Note..."
            required
          />
          <div className="continer_massage">

          <button className="bookmarkBtn" type="submit">
            <span className="IconContainer">
              <BsSendPlusFill className="icon_svg_sav" />
            </span>
            <p className="text">Send</p>
          </button>
          {message && <p className="message">{message}</p>}
        </div>

          </div>
      </form>
    
    </div>
  );
}